import { createContext } from 'react';

export const AbandonedCartIdContext = createContext({
	abandonedCartId: null,
	setAbandonedCartId: () => {},
});

export const AccessoryCountsContext = createContext({
	accessoryCounts: null,
	setAccessoryCounts: () => {},
});

export const AccountDetailsContext = createContext({
	accountDetails: {
		emailAddress: null,
		fullName: null,
		phoneNumber: null,
	},
	setAccountDetails: () => {},
});

export const ActiveModuleContext = createContext({
	activeModule: null,
	setActiveModule: () => {},
});

export const DiscountsContext = createContext({
	activeDiscounts: [],
	setActiveDiscounts: () => {},
	applicableDiscounts: [],
	setApplicableDiscounts: () => {},
});

export const CartHasBoltOns = createContext({
	cartHasBoltOns: null,
	setCartHasBoltOns: () => {},
});

export const CheckoutCartContext = createContext({
	checkoutCart: null,
	setCheckoutCart: () => {},
});

export const CurrentPaymentIntentContext = createContext({
	currentPaymentIntent: null,
	setCurrentPaymentIntent: () => {},
});

export const CurrentVehicleConfigContext = createContext({
	currentVehicleConfig: null,
	setCurrentVehicleConfig: () => {},
});

export const DeliveryTimeContext = createContext({
	deliveryTime: 'Loading...',
	setDeliveryTime: () => {},
});

export const FetchCheckoutContext = createContext({
	fetchCheckoutData: () => {},
	isLoading: false,
});

export const FetchedServicesProvidersContext = createContext({
	fetchedServicesProviders: [],
	setFetchedServicesProviders: () => {},
});

export const GoogleMapsApiKeyContext = createContext({
	googleMapsApiKey: null,
	setGoogleMapsApiKey: () => {},
});

export const LooseAccessoriesContext = createContext({
	looseAccessories: null,
	setLooseAccessories: () => {},
});

export const OemPickUpLocationsContext = createContext({
	oemPickUpLocations: null,
	setOemPickUpLocations: () => {},
});

export const OemVehiclesContext = createContext({
	oemVehicles: null,
	setOemVehicles: () => {},
});

export const OrderIsBeingPlacedContext = createContext({
	submittedPayment: false,
	setSubmittedPayment: () => {},
});

export const PaymentIntentsContext = createContext({
	paymentIntents: null,
	setPaymentIntents: () => {},
});

export const PaymentInvoiceContext = createContext({
	paymentInvoice: null,
	setPaymentInvoice: () => {},
});

export const PaymentInvoiceTotalsContext = createContext({
	paymentInvoiceTotals: null,
	setPaymentInvoiceTotals: () => {},
});

export const RegistrationAddressContext = createContext({
	registrationAddress: {
		addressString: null,
		addressLineOne: null,
		addressLineTwo: null,
		city: null,
		county: null,
		state: null,
		zip: null,
	},
	setRegistrationAddress: () => {},
});

export const RelevantFinancingProgramsContext = createContext({
	relevantFinancingPrograms: null,
	setRelevantFinancingPrograms: () => {},
});

export const SelectedDeliveryOptionContext = createContext({
	selectedDeliveryOption: null,
	setSelectedDeliveryOption: () => {},
});

export const SelectedPaymentOptionContext = createContext({
	selectedPaymentOption: null,
	setSelectedPaymentOption: () => {},
});

export const SelectedRegistrationOptionContext = createContext({
	selectedRegistrationOption: null,
	setSelectedRegistrationOption: () => {},
});

export const SelectedVariantOptionsContext = createContext({
	selectedVariantOptions: null,
	setSelectedVariantOptions: () => {},
});

export const SessionContext = createContext({
	session: null,
	setSession: () => {},
});

export const ShippingAddressSameAsRegistrationAddressContext = createContext({
	shippingAddressSameAsRegistrationAddressContext: false,
	setShippingAddressSameAsRegistrationAddressContext: () => {},
});

export const StackedContext = createContext({
	stacked: null,
	setStacked: () => {},
});

export const StateDataContext = createContext({
	stateData: null,
	setStateData: () => {},
});

export const UniqueAccessoriesContext = createContext({
	uniqueAccessories: null,
	setUniqueAccessories: () => {},
});

export const VehicleConfigContext = createContext({
	vehicleConfig: null,
	setVehicleConfig: () => {},
});

export const VehiclesContext = createContext({
	vehicles: null,
	setVehicles: () => {},
});

export const ServicesProvidersContext = createContext({
	servicesProviders: null,
	updateServicesProviders: () => {},
});

export const VariantImagesContext = createContext({
	variantImages: null,
	setVariantImages: () => {},
});

export const BuyerInfoContext = createContext({
	buyerInfo: null,
	setBuyerInfo: () => {},
});

export const SelectedTradeInOptionContext = createContext({
	selectedTradeInOption: null,
	setSelectedTradeInOption: () => {},
});

export const ModelYearSelectionContext = createContext({
	currentModelYear: null,
	setCurrentModelYear: () => {},
	allModelYears: null,
	handleModelYearChange: () => {},
	isModelYearSelectionEnabled: false,
	// Model year vehicles data
	modelYearVehicles: null,
	setModelYearVehicles: () => {},
	modelYearStockStatus: null,
	setModelYearStockStatus: () => {},
	isLoadingModelYearStock: false,
	setIsLoadingModelYearStock: () => {},
	// Disable checkout when all model years are out of stock
	disableCheckout: false,
	setDisableCheckout: () => {},
});
